import { Styles, generateClasses, dividerClasses as netlineDividerClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const dividerClasses = generateClasses('Divider', ['root'] as const);

const styles: Styles = ({ theme, theme: { spacing } }) => {
  const {
    appHeader: { dividerColor },
  } = getAppFrameTheme(theme);

  return {
    [`&.${netlineDividerClasses.vertical}`]: {
      height: 20,
      opacity: 0.3,
      backgroundColor: dividerColor,
      margin: spacing(0, 0.5),
    },
  };
};

export default styles;
